
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

	@Component({
		components: {
			"scrollbar": VuePerfectScrollbar
		}
	})
export default class TabPage extends Vue {
		@Prop({ type: String, default: "" })
		public title!: string;
}

